module.exports = __webpack_public_path__ + "img/logo-link.4244a97a.svg";